import React from "react";
import { Block } from "@randajan/jet-react/dom/block";

import "./Wiki.scss";
import { Article } from "../../elements/Article/Article";
import { Link } from "@randajan/jet-react/dom/link";
import { Locale } from "../../assets/Locale";

export const Wiki = (props)=>{
    const {} = props;
    const say = Locale.use();

    return (
        <Block className="Wiki" caption={say("navWiki")} level={0}>
            <Article className="slab paragraph" storeId={`wikiPlaybook`}/>
            <Article className="slab paragraph" storeId={`wikiRules`}/>
            <div className="slab">
                <Link to="/aboutUs">{say("wikiAboutLink")}</Link>
            </div>
        </Block>
    );
};
